var _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlumni(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 83,
    viewBox: "0 0 196 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.8253 74.0355L0.484512 54.9458L0.484512 52.9103L83.1144 0.881836L173.281 37.8621V39.9568L86.8253 74.0355Z",
    fill: "url(#paint0_linear_120_77)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M173.281 37.863L83.4442 1.01605L83.1145 0.882812L83.1068 0.890213V4.52458H83.4442V50.0689L85.913 51.1792L173.281 39.9578V37.863Z",
    fill: "url(#paint1_linear_120_77)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.9,
    d: "M83.1069 4.52401V0.889648L0.48465 52.9107V54.9462L83.7586 50.3422L83.4672 4.52401H83.1069Z",
    fill: "url(#paint2_linear_120_77)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8252 74.035L0.484344 54.9453L83.1142 2.96875L173.266 39.949L86.8252 74.035Z",
    fill: "url(#paint3_linear_120_77)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.9,
    d: "M133.142 57.3355C133.802 70.1631 114.534 81.5029 90.1061 82.665C65.6783 83.8271 45.3447 74.3674 44.693 61.5472C44.0413 48.727 63.3091 37.3798 87.7293 36.2177C112.149 35.0556 132.491 44.5153 133.142 57.3355Z",
    fill: "url(#paint4_radial_120_77)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M133.588 72.0582C133.588 75.1374 113.086 80.0819 87.2625 80.9405C61.4392 81.7992 40.0706 77.8465 40.0706 75.241C40.0706 52.5318 33.9368 38.4681 84.5406 36.9803C138.28 35.4407 132.078 45.1595 133.588 72.0582Z",
    fill: "url(#paint5_linear_120_77)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.589 72.0588C133.742 76.352 112.941 80.5489 87.1175 81.4371C61.2942 82.3253 40.2323 79.5644 40.0713 75.2713C39.9103 70.9781 60.7192 66.7812 86.5425 65.9004C112.366 65.0196 133.42 67.7731 133.589 72.0588Z",
    fill: "url(#paint6_radial_120_77)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2,
    d: "M86.5425 65.9017C60.7193 66.7825 39.9104 70.9869 40.0714 75.2726C40.2324 79.5583 61.2943 82.3267 87.1176 81.4384C112.941 80.5502 133.742 76.3533 133.589 72.0601C133.435 67.767 112.366 64.9839 86.5425 65.9017ZM87.0639 79.9654C83.8743 80.0765 80.6924 80.1283 77.5949 80.1283C53.1977 80.1283 42.1109 76.9232 41.6048 75.2134C42.0955 73.0298 57.9744 68.3666 86.5962 67.3895C89.7858 67.2785 92.9677 67.2193 96.0653 67.2193C120.462 67.2193 131.542 70.4243 132.055 72.1416C131.565 74.3177 115.678 78.9736 87.0639 79.958V79.9654Z",
    fill: "url(#paint7_linear_120_77)"
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M124.019 17.6611C124.019 17.6611 136.931 22.4724 142.819 32.5687C149.719 44.4118 153.553 56.9952 163.521 62.9167C173.488 68.8383 181.922 68.0981 181.922 68.0981V65.8775C176.331 65.8044 170.869 64.2461 166.135 61.3735C161.402 58.5009 157.579 54.4251 155.087 49.5932C149.252 38.8011 142.819 17.0245 124.019 17.6611Z",
    fill: "url(#paint8_radial_120_77)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M195.095 68.0629C195.095 68.0629 185.266 70.9792 178.48 69.9948C171.694 69.0103 168.513 66.2272 168.513 65.1317C168.513 64.0362 170.13 61.1124 178.434 61.7934C183.421 62.2008 188.441 61.9844 193.37 61.1494C194.374 62.6742 194.988 64.8948 195.095 68.0629Z",
    fill: "url(#paint9_radial_120_77)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M194.082 62.5098C191.621 63.1593 189.093 63.5465 186.545 63.6645C183.472 63.7954 180.393 63.6641 177.344 63.2722C181.125 64.161 185.02 64.5126 188.907 64.3158C190.8 64.2603 192.688 64.1096 194.565 63.8643C194.433 63.4037 194.272 62.9513 194.082 62.5098Z",
    fill: "url(#paint10_radial_120_77)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M194.933 65.959C194.442 66.0922 193.951 66.2181 193.399 66.3365C190.398 67.026 187.34 67.457 184.26 67.6244C187.864 67.8055 191.476 67.5041 194.994 66.7288C194.986 66.4623 194.963 66.2107 194.933 65.959Z",
    fill: "url(#paint11_radial_120_77)"
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_120_77",
    x1: 78.6751,
    y1: -15.9798,
    x2: 90.6001,
    y2: 81.3277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_120_77",
    x1: 120.523,
    y1: -15.668,
    x2: 128.721,
    y2: 51.2661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_120_77",
    x1: 37.4331,
    y1: -5.22437,
    x2: 45.4594,
    y2: 60.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_120_77",
    x1: 78.8742,
    y1: -13.4192,
    x2: 90.4559,
    y2: 81.1243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_120_77",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(90.3358 -9.08723) scale(40.6185 26.1421)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#393434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#534F4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#969494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_120_77",
    x1: 39.8329,
    y1: 58.9715,
    x2: 133.58,
    y2: 58.9715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_120_77",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(116.997 106.248) scale(74.2266 71.6584)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_120_77",
    x1: 40.0714,
    y1: 73.6664,
    x2: 133.581,
    y2: 73.6664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D5273"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#40445D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#303243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#242630"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#1D1E25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1C21"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_120_77",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.184 38.4532) scale(43.2816 41.7841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_120_77",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.443 57.3817) rotate(-81.6664) scale(22.4628 23.2347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_120_77",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(184.605 61.1034) scale(21.3839 20.644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_120_77",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(190.386 65.8257) scale(11.3629 10.9697)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFCF4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFC529"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#996E00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlumni);
export default __webpack_public_path__ + "static/media/alumni.0adc938b26ed7154bd9584fdbbecc925.svg";
export { ForwardRef as ReactComponent };